import { useMemo, useCallback } from 'react';
import { matchesCondtPendente, matchesCondtLiberado, groupOrdersByCity } from '../utils/futuraRetornoCondt';

/**
 * Deriva listas e contadores das abas Retorno Pendente/Liberado (UI na seção FUTURA; fonte = todas as seções do técnico).
 * @param {(order: object) => boolean} [matchesSearch] — quando definido, restringe Pendente/Liberado (ex.: busca + SLA).
 */
export function useFuturaRetornoTechnicianLogic({
  groupName,
  ordersForCondtTabs,
  futuraHeaderTab,
  filteredOrders,
  matchesSearch
}) {
  const showFuturaRetornoPendente = groupName === 'FUTURA' && futuraHeaderTab === 'pendente';
  const showFuturaRetornoLiberado = groupName === 'FUTURA' && futuraHeaderTab === 'liberado';
  const futuraRetornoHeaderLocked = showFuturaRetornoPendente || showFuturaRetornoLiberado;

  const filterPendente = useCallback((o) => matchesCondtPendente(o), []);
  const filterLiberado = useCallback((o) => matchesCondtLiberado(o), []);

  const futuraPendenteOrdersAll = useMemo(() => {
    if (groupName !== 'FUTURA') return [];
    let list = ordersForCondtTabs.filter(filterPendente);
    if (matchesSearch) list = list.filter(matchesSearch);
    return list;
  }, [groupName, ordersForCondtTabs, filterPendente, matchesSearch]);

  const futuraLiberadoOrdersAll = useMemo(() => {
    if (groupName !== 'FUTURA') return [];
    let list = ordersForCondtTabs.filter(filterLiberado);
    if (matchesSearch) list = list.filter(matchesSearch);
    return list;
  }, [groupName, ordersForCondtTabs, filterLiberado, matchesSearch]);

  const listOrdersRetornoView = useMemo(() => {
    if (showFuturaRetornoPendente) return futuraPendenteOrdersAll;
    if (showFuturaRetornoLiberado) return futuraLiberadoOrdersAll;
    return null;
  }, [showFuturaRetornoPendente, showFuturaRetornoLiberado, futuraPendenteOrdersAll, futuraLiberadoOrdersAll]);

  const groupedRetornoByCity = useMemo(() => {
    if (!listOrdersRetornoView || listOrdersRetornoView.length === 0) return null;
    return groupOrdersByCity(listOrdersRetornoView);
  }, [listOrdersRetornoView]);

  const inboxFallbackTab =
    groupName === 'FUTURA' && !futuraRetornoHeaderLocked && filteredOrders.length === 0
      ? futuraPendenteOrdersAll.length > 0
        ? 'pendente'
        : futuraLiberadoOrdersAll.length > 0
          ? 'liberado'
          : null
      : null;

  const groupedInboxFallback = useMemo(() => {
    if (!inboxFallbackTab) return null;
    const list = inboxFallbackTab === 'pendente' ? futuraPendenteOrdersAll : futuraLiberadoOrdersAll;
    if (!list.length) return null;
    return groupOrdersByCity(list);
  }, [inboxFallbackTab, futuraPendenteOrdersAll, futuraLiberadoOrdersAll]);

  const headerFuturaCount = futuraRetornoHeaderLocked
    ? (listOrdersRetornoView ? listOrdersRetornoView.length : 0)
    : filteredOrders.length;

  return {
    showFuturaRetornoPendente,
    showFuturaRetornoLiberado,
    futuraRetornoHeaderLocked,
    futuraPendenteOrdersAll,
    futuraLiberadoOrdersAll,
    listOrdersRetornoView,
    groupedRetornoByCity,
    groupedInboxFallback,
    inboxFallbackTab,
    headerFuturaCount
  };
}
